{
  "completed": "Concluído: ",
  "current": "Atual: ",
  "notCompleted": "Incompleto: ",
  "steplist": "Lista de etapas"
}
